import { useTranslation } from 'next-i18next';

import typographyFixText from 'utils/typograf';

type Returned = (
  text?: string,
  params?: Record<string, string | number>,
) => string;

export default function useTranslationAndTypograph(ns = 'common'): Returned {
  const { t: _t } = useTranslation(ns);

  function t(text = '', params?: Record<string, string | number>): string {
    return typographyFixText(_t(text, params));
  }

  return t;
}
